import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home/Home.vue'
import PrivacyPolicy from '../views/other/PrivacyPolicy.vue'
import AboutUs from '../views/other/AboutUs.vue'
import Query from '../views/query/Query'
import ContactUs from '../views/other/ContactUs.vue'
import InApply from '../views/inapply/InApply'
import InApplyDetail from '../views/inapply/InApplyDetail'
import ProofForUseApply from '../views/inapply/ProofForUseApply'
import CompanyLicenseUploadApply from '../views/inapply/companyLicenseUploadApply'
import UserPolicy from '../views/other/UserPolicy.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        name: 'index',
        redirect: '/home'
    },
    {
        path: '/home',
        name: 'home',
        component: Home
    },
    {
        path: '/InApply/:id/:companyName',
        name: 'InApplyWithInfo',
        component: InApply
    },
    {
        path: '/InApply',
        name: 'InApply',
        component: InApply
    },
    {
        path: '/ChangeApply/:id/:enterpriseId/:companyName',
        name: 'ChangeApply',
        component: InApply
    },
    {
        path: '/CompanyLicenseUploadApply/:enterpriseId',
        name: 'CompanyLicenseUploadApply',
        component: CompanyLicenseUploadApply
    },
    {
        path: '/ProofForUseApply/:enterpriseId/:applyId',
        name: 'ProofForUseApply',
        component: ProofForUseApply
    },
    {
        path: '/InApplyDetail/:id',
        name: 'InApplyDetail',
        component: InApplyDetail
    },
    {
        path: '/query',
        name: 'Query',
        component: Query
    },
    // {
    //     path: '/privacyPolicy',
    //     name: 'privacyPolicy',
    //     component: PrivacyPolicy
    // },
    {
        path: '/aboutUs',
        name: 'aboutUs',
        component: AboutUs
    },
    {
        path: '/contactUs',
        name: 'contactUs',
        component: ContactUs
    },
    // {
    //     path: '/userPolicy',
    //     name: 'userPolicy',
    //     component: UserPolicy
    // },
]

const router = new VueRouter({
    routes
})

export default router
